<template>
    <div class="footer">
        <div class="footer-wrapper" v-if="!isPhone">
            <!-- <p class="footer-top" v-show="!isPhone">联盟单位</p>
            <p class="footer-union-orgs" v-show="!isPhone">
                <ul>
                    <li v-for="(item, i) in unionOrgs" :key="i">
                        <a :href="item.href" target="_blank">{{item.name}}
                            <span v-show="i < unionOrgs.length - 1" class="aline">|</span>
                        </a>
                    </li>
                </ul>
            </p>
            <p class="footer-top" v-show="!isPhone">成员单位</p>
            <p class="footer-union-deps" v-show="!isPhone">
                <ul>
                    <li v-for="(item, i) in unionDeps" :key="i">
                        <span>{{item}}</span>
                        <span v-show="i < unionDeps.length - 1" class="aline">|</span>
                    </li>
                </ul>
            </p> -->
            <!-- <p class="footer-top" v-show="!isPhone">友情链接</p> -->
            <!-- <p class="footer-union-orgs" v-show="!isPhone">
                <ul>
                    <li v-for="(item, i) in unionLinks" :key="i">
                        <a :href="item.href" target="_blank">{{item.name}}
                            <span v-show="i < unionLinks.length - 1" class="aline">|</span>
                        </a>
                    </li>
                </ul>
            </p> -->
            <!-- 改版页脚 -->
            <div class="footer-flex">
                <div class="footer-title-left">指导单位</div>
                <div class="footer-content-right">
                    <span>省委宣传部</span>
                </div>
            </div>
            <div class="footer-flex">
                <div class="footer-title-left">牵头单位</div>
                <div class="footer-content-right">
                    <span>省委网信办</span>
                </div>
            </div>
            <div class="footer-flex">
                <div class="footer-title-left">成员单位</div>
                <div class="footer-content-right">
                    <span v-for="(item, index) in partUnit" :key="index">
                        <a v-if="item.url" class="has-underline" :href="item.url" target="_blank">{{ item.name }}</a>
                        <span v-else style="margin-right: 0;">{{ item.name }}</span>
                    </span>
                </div>
            </div>
            <div class="footer-flex">
                <div class="footer-title-left">参与单位</div>
                <div class="footer-content-right expand-warpper">
                    <span class="custom-expand-one">
                        <a class="custom-icon">21市州网信办</a>
                        <div class="expand-unit expand-unit-one">
                            <span v-for="(item, index) in expandUnit1" :key="index">{{ item }}</span>
                        </div>
                    </span>
                    <span class="custom-expand-two">
                        <a class="custom-icon">中央驻川和省主要新闻单位及所属新闻网站新媒体平台</a>
                        <div class="expand-unit expand-unit-two">
                            <span v-for="(item, index) in expandUnit2" :key="index">
                                <a class="has-underline" v-if="item.url" :href="item.url" target="_blank">{{ item.name }}</a>
                                <span v-else>{{ item.name }}</span>
                            </span>
                        </div>
                    </span>
                    <span class="custom-expand-three">
                        <a class="custom-icon ">行业协会</a>
                        <div class="expand-unit expand-unit-three">
                            <span v-for="(item, index) in expandUnit3" :key="index">
                                <a class="has-underline" :href="item.url" target="_blank">{{ item.name }}</a>
                            </span>
                        </div>
                    </span>
                    <span class="custom-expand-four">
                        <a class="custom-icon">商业网站/平台在川机构</a>
                        <div class="expand-unit expand-unit-four">
                            <span v-for="(item, index) in expandUnit4" :key="index">
                                <a class="has-underline" :href="item.url" target="_blank">{{ item.name }}</a>
                            </span>
                        </div>
                    </span>
                </div>
            </div>
            <div class="footer-flex">
                <div class="footer-title-left">友情链接</div>
                <div class="footer-content-right">
                    <span v-for="(item, i) in unionLinks" :key="i">
                        <a class="has-underline" :href="item.href" target="_blank">{{item.name}}</a>
                    </span>
                </div>
            </div>
            <p class="footer-host">四川互联网举报辟谣平台——中共四川省委网信办主管主办</p>
            <p class="footer-licence">
                <!-- <a v-show="!isScPiyaoOrgCn" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010402000435" target="_blank">
                    <img src="http://wapcdn.thecover.cn/web/20170913/police_record.png" style="width: auto; vertical-align: middle" />
                    川公网安备 51010402000435号</a> -->
                <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备15028104号-{{beianNum}}</a>
            </p>
        </div>
        <div class="footer-wrapper" v-if="isPhone">
            <p class="footer-host">四川互联网举报辟谣平台——中共四川省委网信办主管主办</p>
            <p class="footer-licence">
                <a v-show="!isScPiyaoOrgCn" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010402000435" target="_blank">
                    <img src="http://wapcdn.thecover.cn/web/20170913/police_record.png" style="width: auto; vertical-align: middle" />
                    川公网安备 51010402000435号</a>
                <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备15028104号-{{beianNum}}</a>
            </p>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import unionData from '../utils/unionData'
export default {
    name: 'Footer',
    data() {
        return {
            partUnit: [
                {
                    name: '省法院',
                    url: 'http://scfy.scssfw.gov.cn/index.shtml'
                },
                {
                    name: '省检察院',
                    url: 'http://www.sc.jcy.gov.cn'
                },
                {
                    name: '省委统战部',
                    url: 'http://www.sctyzx.gov.cn'
                },
                {
                    name: '省委政法委',
                    url: 'https://www.sichuanpeace.gov.cn'
                },
                {
                    name: '省委外办',
                    url: 'https://www.scwsb.gov.cn'
                },
                {
                    name: '省委金融办',
                    url: 'http://dfjrjgj.sc.gov.cn'
                },{
                    name: '省委台办',
                    url: 'https://gd.huaxia.com/jxtf/tbdt'
                },
                {
                    name: '省委党史研究室',
                    url: 'http://www.scds.org.cn'
                },
                {
                    name: '省发展改革委',
                    url: 'https://fgw.sc.gov.cn'
                },
                {
                    name: '经济和信息化厅',
                    url: 'https://jxt.sc.gov.cn'
                },
                {
                    name: '教育厅',
                    url: 'http://edu.sc.gov.cn'
                },
                {
                    name: '科技厅',
                    url: 'https://kjt.sc.gov.cn'
                },
                {
                    name: '公安厅',
                    url: 'http://gat.sc.gov.cn'
                },
                {
                    name: '民政厅',
                    url: 'https://mzt.sc.gov.cn'
                },
                {
                    name: '司法厅',
                    url: 'http://sft.sc.gov.cn'
                },
                {
                    name: '财政厅',
                    url: 'http://czt.sc.gov.cn'
                },
                {
                    name: '人力资源社会保障厅',
                    url: 'http://rst.sc.gov.cn/rst/index.shtml'
                },
                {
                    name: '自然资源厅',
                    url: 'https://dnr.sc.gov.cn'
                },
                {
                    name: '生态环境厅',
                    url: 'http://sthjt.sc.gov.cn'
                },
                {
                    name: '住房城乡建设厅',
                    url: 'http://jst.sc.gov.cn'
                },
                {
                    name: '交通运输厅',
                    url: 'http://jtt.sc.gov.cn'
                },
                {
                    name: '农业农村厅',
                    url: 'http://nynct.sc.gov.cn'
                },
                {
                    name: '商务厅',
                    url: 'https://swt.sc.gov.cn'
                },
                {
                    name: '文化和旅游厅',
                    url: 'http://wlt.sc.gov.cn'
                },
                {
                    name: '省卫生健康委',
                    url: 'https://wsjkw.sc.gov.cn'
                },
                {
                    name: '退役军人事务厅',
                    url: 'https://dva.sc.gov.cn'
                },
                {
                    name: '应急管理厅',
                    url: 'https://yjt.sc.gov.cn'
                },
                {
                    name: '省国资委',
                    url: 'http://gzw.sc.gov.cn'
                },
                {
                    name: '省市场监管局',
                    url: 'http://scjgj.sc.gov.cn'
                },
                {
                    name: '省体育局',
                    url: 'https://tyj.sc.gov.cn'
                },
                {
                    name: '省医保局',
                    url: 'http://ylbzj.sc.gov.cn'
                },
                {
                    name: '省中医药局',
                    url: 'https://sctcm.sc.gov.cn'
                },
                {
                    name: '省药监局',
                    url: 'http://yjj.sc.gov.cn'
                },
                {
                    name: '四川气象局',
                    url: 'http://sc.cma.gov.cn'
                },
                {
                    name: '人行四川省分行',
                    url: 'http://chengdu.pbc.gov.cn'
                },
                {
                    name: '四川证监局',
                    url: 'http://www.csrc.gov.cn/sichuan/'
                },
                {
                    name: '团省委',
                    url: 'https://www.scyol.com'
                },
                {
                    name: '省科协',
                    // url: 'https://www.sckx.org.cn'
                    url: ''
                },
                {
                    name: '省工商联',
                    url: 'http://www.scsgsl.cn'
                },
            ],
            expandUnit1: [
                '成都市委网信办',
                '自贡市委网信办',
                '攀枝花市委网信办',
                '泸州市委网信办',
                '德阳市委网信办',
                '绵阳市委网信办',
                '广元市委网信办',
                '遂宁市委网信办',
                '内江市委网信办',
                '乐山市委网信办',
                '南充市委网信办',
                '眉山市委网信办',
                '宜宾市委网信办',
                '广安市委网信办',
                '达州市委网信办',
                '雅安市委网信办',
                '巴中市委网信办',
                '资阳市委网信办',
                '阿坝州委网信办',
                '甘孜州委网信办',
                '凉山州委网信办',
            ],
            expandUnit2: [
                {
                    name: '人民日报四川分社',
                    url: ''
                },
                {
                    name: '新华通讯社四川分社',
                    url: ''
                },
                {
                    name: '光明日报四川记者站',
                    url: ''
                },
                {
                    name: '经济日报四川记者站',
                    url: ''
                },
                {
                    name: '中央广播电视总台四川总站',
                    url: 'https://local.cctv.com/sichuan'
                },
                {
                    name: '中国新闻社四川分社',
                    url: 'http://www.sc.chinanews.com.cn'
                },
                {
                    name: '四川日报报业集团',
                    url: 'http://www.cbgw.cn'
                },
                {
                    name: '四川广播电视台',
                    url: 'https://www.sctv.com'
                },
                {
                    name: '四川新传媒集团',
                    url: 'https://www.scxcm.com.cn'
                }
            ],
            expandUnit3: [
                {
                    name: '四川省医学会',
                    url: 'https://www.sma.org.cn/cn/index/353'
                },
                {
                    name: '四川省医师协会',
                    url: 'http://www.scysxh.org/home'
                },
                {
                    name: '四川省护理学会',
                    url: 'http://www.schlxh.cn'
                },
                {
                    name: '四川省食品生产安全协会',
                    url: 'https://www.buy12365.com'
                },
                {
                    name: '四川省律师协会',
                    url: 'http://www.scslsxh.com'
                },
                {
                    name: '四川省老年学学会',
                    url: 'https://www.scaua1985.com'
                }
            ],
            expandUnit4: [
                {
                    name: '新浪',
                    url: 'https://www.sina.com.cn'
                },
                {
                    name: '腾讯',
                    url: 'https://www.tencent.com'
                },
                {
                    name: '抖音',
                    url: 'https://www.douyin.com'
                },
                {
                    name: '快手',
                    url: 'https://www.kuaishou.com'
                }
            ]
        }
    },
    computed: {
        ...mapState(['columnList']),
        isPhone() {
            return this.$Common.Attribute.isMb();
        },
        unionOrgs() {
            return unionData.unionOrgs
        },
        unionDeps() {
            return unionData.unionDeps
        },
        isProduction() {
            return location.host == 'piyao-web.thecover.cn' || location.host == 'scpiyao.org.cn' || location.host == 'www.scpiyao.org.cn'
        },
        cyLocationHref() {
            if(this.isProduction) return 'https://piyao-web.thecover.cn/cy';
            else return 'https://piyao-web.fm-dev.thecover.cn/cy';
        },
        unionLinks() {
            return unionData.unionLinks.concat([{
                name: '川渝互联网辟谣平台',
                href: this.cyLocationHref,
            }])
        },
        beianNum() {
            if (location.host == 'scpiyao.org.cn' || location.host == 'www.scpiyao.org.cn') {
                return unionData.scpiyaoOrgCn.beianNumber
            } else {
                return unionData.piyaoWeb.beianNumber
            }
        },
        isScPiyaoOrgCn() {
            return location.host == 'scpiyao.org.cn' || location.host == 'www.scpiyao.org.cn'
        }
    },
}
</script>
<style lang="less">
.pc-wrapper {
    .footer {
        .footer-wrapper {
            width: 100%;
            // height: 19rem;
            padding-top: 1.1111rem;
            padding-bottom: .8333rem;
            background: #F7F8F9;
            box-sizing: border-box;
            color: #666666;
            font-size: .7778rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            padding-left: .6667rem;
            .footer-flex {
                display: flex;
                margin-bottom: .6667rem;
                .footer-title-left {
                    width: 4.2222rem;
                    font-weight: 500;
                    color: #333333;
                }
                .expand-warpper {
                    position: relative;
                    .expand-unit {
                        position: absolute;
                        left: 0;
                        top: 1.2rem;
                        width: 100%;
                        padding: .5rem;
                        display: none;
                        flex-wrap: wrap;
                        z-index: 99;
                        box-sizing: border-box;
                        background-color: #fff;
                        cursor: pointer;
                        box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.15);
                        span {
                            margin-right: 1.7rem;
                            margin-bottom: .6667rem;
                        }
                    }
                    .expand-unit-one::after {
                        content: '';
                        position: absolute;
                        top: -0.2778rem;
                        left: 2.2222rem;
                        display: block;
                        width: .5rem;
                        height: .5rem;
                        transform: rotate(45deg);
                        box-shadow: -1px -1px 2px 0px rgba(0,0,0,0.15);
                        background-color: #fff;
                    }
                    .expand-unit-two::after {
                        content: '';
                        position: absolute;
                        top: -0.2778rem;
                        left: 16.6667rem;
                        display: block;
                        width: .5rem;
                        height: .5rem;
                        transform: rotate(45deg);
                        box-shadow: -1px -1px 2px 0px rgba(0,0,0,0.15);
                        background-color: #fff;
                    }
                    .expand-unit-three::after {
                        content: '';
                        position: absolute;
                        top: -0.2778rem;
                        left: 28.5rem;
                        display: block;
                        width: .5rem;
                        height: .5rem;
                        transform: rotate(45deg);
                        box-shadow: -1px -1px 2px 0px rgba(0,0,0,0.15);
                        background-color: #fff;
                    }
                    .expand-unit-four::after {
                        content: '';
                        position: absolute;
                        top: -0.2778rem;
                        left: 35rem;
                        display: block;
                        width: .5rem;
                        height: .5rem;
                        transform: rotate(45deg);
                        box-shadow: -1px -1px 2px 0px rgba(0,0,0,0.15);
                        background-color: #fff;
                    }
                }
                .footer-content-right {
                    flex: 1;
                    display: flex;
                    flex-wrap: wrap;
                    span {
                        margin-right: 1.7778rem;
                        &:hover .custom-icon {
                            text-decoration: none;
                        }
                        
                    }
                    .no-underline {
                        a {
                            text-decoration: none;
                        }
                    }
                    a {
                        color: #666666;
                        cursor: pointer;
                    }
                    .has-underline {
                        text-decoration: underline;
                    }
                    .custom-icon {
                        display: block;
                        text-decoration: underline;
                        position: relative;
                        &::after {
                            content: '';
                            display: block;
                            position: absolute;
                            right: -0.8rem;
                            top: 40%;
                            width: 0;
                            height: 0;
                            border: .3rem solid transparent;
                            border-top-color: #666666;
                        }
                    }
                    .custom-expand-one:hover .expand-unit-one {
                        display: flex;
                    }
                    .custom-expand-two:hover .expand-unit-two {
                        display: flex;
                    }
                    .custom-expand-three:hover .expand-unit-three {
                        display: flex;
                    }
                    .custom-expand-four:hover .expand-unit-four {
                        display: flex;
                    }
                }
            }
            
            // .footer-top {
            //     margin-bottom: 0.625rem;
            // }
            // .footer-union-orgs {
            //     line-height: 1.25rem;
            //     margin-bottom: 1.375rem;
            //     ul {
            //         li {
            //             display: inline-block;
            //             line-height: 1.575rem;
            //             a {
            //                 color: inherit;
            //                 text-decoration: underline;
            //             }
            //         }
            //     }
            // }
            // .footer-union-deps {
            //     margin-bottom: 1.375rem;
            //     ul {
            //         li {
            //             display: inline-block;
            //             line-height: 1.575rem;
            //         }
            //     }
            // }
            // .aline {
            //     display: inline-block;
            //     // border-left: 1px solid #6e6e6d;
            //     // height: 0.875rem;
            //     margin: 0 0.3125rem;
            // }
            .footer-host {
                color: #006DF1;
                margin-top: 1.375rem;
                margin-bottom: 1.375rem;
                display: flex;
                justify-content: center;
            }
            .footer-licence {
                display: flex;
                justify-content: center;
                color: #999999;
                font-size: 0.75rem;
                line-height: 1.125rem;
                a {
                    color: inherit;
                    text-decoration: none;
                    margin-right: 0.5rem;
                }
            }
        }
    }
}
.wap-wrapper {
    .footer {
        .footer-wrapper {
            width: 100vw;
            background: #F7F8F9;
            color: #727272;
            text-align: center;
            padding: 3.867vw 4.533vw 1.867vw;
            box-sizing: border-box;
            // margin-top: 4.267vw;
            .footer-top {
                margin-bottom: 1.333vw;
            }
            .footer-union-orgs {
                line-height: 4vw;
                margin-bottom: 2.933vw;
                color: #333333;
                ul {
                    li {
                        display: inline-block;
                        line-height: 1.375rem;
                        a {
                            color: inherit;
                            text-decoration: underline;
                        }
                    }
                }
            }
            .footer-union-deps {
                ul {
                    li {
                        display: inline-block;
                        line-height: 2.933vw;
                    }
                }
            }
            .aline {
                display: inline-block;
                margin: 0 0.533vw;
            }
            .footer-host {
                color: #727272;
                font-size: 3.2vw;
                line-height: 5.333vw;
                margin-top: 4.8vw;
                margin-bottom: 2.933vw;
            }
            .footer-licence {
                color: #999999;
                font-size: 2.667vw;
                line-height: 4.8vw;
                margin-bottom: 0.933vw;
                a {
                    color: inherit;
                    text-decoration: none;
                    margin-right: 1.333vw;
                }
            }
            .footer-version {
                color: #999999;
                font-size: 2.667vw;
                line-height: 3.733vw;
            }
        }
    }
}
</style>